import { z } from 'zod';

export const activitiesSchema = z.object({
  viewDriverGroups: z.boolean(),
});
